const JobListEmptyState = {
  MATCH: 'NO_PROFILE_MATCHES',
  SEARCH: 'NO_SEARCH_RESULTS',
}
Object.freeze(JobListEmptyState)
export { JobListEmptyState }
